import { useEffect, useRef, useState } from 'react';

import { useAutoCollapseProps, useAutoCollapseReturnType } from '../types';
import createNonCollapsablePageRoutes from '../utils/createNonCollapsablePageRoutes';

import remotes from '../../../../remotes';

const useAutoCollapse = ({ pathname }: useAutoCollapseProps): useAutoCollapseReturnType => {
  const autoCollapseRouteListRef = useRef<RegExp[]>([]);
  const [autoCollapse, setAutoCollapse] = useState(false);

  useEffect(() => {
    if (!autoCollapseRouteListRef.current.length) {
      autoCollapseRouteListRef.current = createNonCollapsablePageRoutes({
        remotes,
      });
    }
  }, []);

  useEffect(() => {
    const isNonCollapsable = autoCollapseRouteListRef.current.some(regex => regex.test(pathname));

    setAutoCollapse(!isNonCollapsable);
  }, [pathname]);

  return { autoCollapse };
};

export default useAutoCollapse;
